import { atom } from "recoil";

import { Dimension } from "../models/dimension-funnel";

export const breakdownDimensionAtom = atom({
    key: "selectedBreakdownDimension",
    default: Dimension.COUNTRY,
});
